import type { FlightRoute } from 'common/packageCache';
import moment from 'moment';

function renderCreatedAtCell(text: string, record: FlightRoute): string {
  return moment(record.creationTime).format('YYYY-MM-DD');
}

export default renderCreatedAtCell;
